import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { sectionNum } from '../../../actions/section';
import NumChoose from './NumChoose';
import NumWatch from './NumWatch';
import NumTrack from './NumTrack';
import NumPic from './NumPic';
import { shadowSize } from '../../../utils/utils';

export class Num extends React.Component {
	componentDidMount() {
		this.props.sectionNum();
		shadowSize();
	}
	render() {
        return (
			<div id="num" className="char section">
			    <NumChoose />
			    <NumWatch />
			    <NumTrack />
			    <NumPic />
			</div>
		);
    }
};

const mapDispatchToProps = (dispatch) => ({
	sectionNum: () => dispatch(sectionNum())
});

export default connect(undefined, mapDispatchToProps)(Num);



// WEBPACK FOOTER //
// ./src/components/sections/num/Num.js